import { cn, Div, Image } from '@scatterlab/zeta-core';
import { memo } from 'react';

import ZetaWatermarkPng from '../assets/logo/zeta_watermark.png';
import ZetaWatermarkEditedPng from '../assets/logo/zeta_watermark_edited.png';
import ZetaWatermarkRoomSvg from '../assets/logo/zeta_watermark_room.svg?react';
import ZetaWatermarkRoomWBgPng from '../assets/logo/zeta_watermark_room_w_bg.png';

type ZetaWatermarkProps = {
  className?: string;
};

export const ZetaWatermarkRoom = memo(() => (
  <Div className="ml-1.5 select-none">
    <ZetaWatermarkRoomSvg className="h-[20px] w-[39px] select-none" />
  </Div>
));

export const ZetaWatermarkRoomWBg = memo(
  ({ className }: ZetaWatermarkProps) => (
    <Image
      src={ZetaWatermarkRoomWBgPng}
      className={cn(
        'my-[-18.5px] ml-[-16px] mr-[-18px] h-[51px] w-[65px] select-none',
        className,
      )}
      alt="zeta"
    />
  ),
);

export const ZetaWatermark = memo(({ className }: ZetaWatermarkProps) => (
  <Image
    src={ZetaWatermarkPng}
    className={cn(
      'my-[-18.5px] ml-[-16px] mr-[-18px] h-[51px] w-[65px] select-none',
      className,
    )}
    alt="zeta"
  />
));

export const ZetaWatermarkEdited = memo(({ className }: ZetaWatermarkProps) => (
  <Image
    src={ZetaWatermarkEditedPng}
    className={cn(
      'my-[-18.5px] ml-[-16px] mr-[-18px] h-[51px] w-[65px] select-none',
      className,
    )}
    alt="zeta"
  />
));
